import { Button, FormControl, InputLabel, MenuItem, Paper, Select, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from "@mui/material";
import React, { useState } from "react";

const accStatus = [
    {status: 'PENDING-VERIFICATION', title: 'Pending Verfication', description: 'Account Pending Verification'},
    {status: 'ACTIVE', title: 'Active', description: 'Account is active and in good condition'},
    {status: 'SUSPENDED', title: 'Suspended', description: 'Account has been suspended'},
    {status: 'DEACTIVATED', title: 'Deactivated', description: 'Account is deactivated'},
    {status: 'BANNED', title: 'Banned', description: 'Account is permnently banned'},
    {status: 'CLOSED', title: 'Closed', description: 'Account is parmanently closed'},
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function createData(
  name: string,
  calories: number,
  fat: number,
  carbs: number,
  protein: number,
) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
  createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
  createData('Eclair', 262, 16.0, 24, 6.0),
  createData('Cupcake', 305, 3.7, 67, 4.3),
  createData('Gingerbread', 356, 16.0, 49, 3.9),
];

const SellersTable = () => {
    const [accountStatus, setAccountStatus]=useState("ACTIVE")

    const handleChange = (event:any) => {
        setAccountStatus(event.target.value)
    }
    return (
        <>
        <div className="pb-5 w-60">
            <FormControl fullWidth>
                <InputLabel id="status-select-lable">Account Status</InputLabel>
                <Select
                labelId="status-label"
                id="status-select"
                value={accountStatus}
                label="Account Status"
                onChange={handleChange}
                >
                    {accStatus.map((item) => <MenuItem value={item.status}>{item.title}</MenuItem>)}
                    
                </Select>
            </FormControl>
        </div>

        <TableContainer component={Paper}>
              <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Seller Name</StyledTableCell>
                    <StyledTableCell>Email</StyledTableCell>
                    <StyledTableCell align="right">Mobile</StyledTableCell>
                    <StyledTableCell align="right">GSTIN</StyledTableCell>
                    <StyledTableCell align="right">Business Name</StyledTableCell>
                    <StyledTableCell align="right">Account Status</StyledTableCell>
                    <StyledTableCell align="right">Change Status</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <StyledTableRow key={row.name}>
                      <StyledTableCell component="th" scope="row">
                        {row.name}
                      </StyledTableCell>
                      <StyledTableCell align="right">{row.calories}</StyledTableCell>
                      <StyledTableCell align="right">{row.fat}</StyledTableCell>
                      <StyledTableCell align="right">{row.carbs}</StyledTableCell>
                      <StyledTableCell align="right">{row.protein}</StyledTableCell>
                      <StyledTableCell align="right">{row.protein}</StyledTableCell>
                      <StyledTableCell align="right"><Button>Change Status</Button></StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
        </>
    )
}

export default SellersTable